  <template>
    <main v-bind:id="isSwitchedCustom">
      <section id="init"><!--Início seção inicial-->
        <div class="columns">
          <div class="column" id="init-info">
            <div class="center">
              <div id="init-title">
                <h1 class="title-part">NÓS CONSTRUIMOS</h1>
                <h1 class="title-part overlaid" id="conexoes">CONEXÕES</h1>
              </div>
              <p class="center font-base">Nossa plataforma centraliza todos os seus sensores IoT em um único local, oferecendo acesso fácil e rápido às informações. 
                Cadastre, monitore e gerencie dispositivos em tempo real, otimizando processos e melhorando a eficiência operacional,
                permitindo que você foque no que realmente importa: inovar e crescer. 
                </p>
              <div id="init-button">
                <b-button type="is-primary" id="init-signIn-button" tag="router-link"
                  :to="{ path: '/registro' }">REGISTRE-SE</b-button>
                <p id="client-portfolio-text" class="font-xs">Transforme dados dispersos em insights valiosos com nossa solução integrada..</p>
              </div>
            </div>
          </div>
          <img src="../assets/aboutUS-init.svg" id="aboutUS-init">
        </div>
      </section><!--Fim seção inicial-->
      <section class="parallax second" id="our-solutions">
    <!-- Início seção our solutions -->
    <div class="solutions-title">
      <h1 class="font-5xl">Nossas Soluções</h1>
    </div>
    <div class="columns solutions-itens">
      <div class="column ">
        <div class="item">
          <img src="../assets/smartcities.png" alt="">
          <div class="card-text">
            <h3>Smart City</h3>
            <p class="font-base card-text p">Cidade que usa tipos diferentes de sensores eletrônicos para coletar dados e usá-los para gerenciar
              recursos e ativos eficientemente.</p>
          </div>
            <b-button rounded class="mb-4 saiba-mais-button" @click="cityAlert()">SAIBA MAIS</b-button><br />
        </div>
      </div>
      <div class="column">
        <div class="item">
          <img src="../assets/smartcampus.jpg" alt="">
          <div class="card-text">
            <h3>Smart Campus</h3>
            <p class="font-base card-text p">Conceito que promove o desenvolvimento e implementação de soluções tecnológicas e sustentáveis focadas em
              áreas universitárias</p>
          </div>
          <b-button rounded class="mb-4 saiba-mais-button" @click="campusAlert()">SAIBA MAIS</b-button><br />
        </div>
      </div>
      <div class="column">
        <div class="item">
          <img src="../assets/smartfarm.jpg" alt="">
          <div class="card-text">
            <h3>Smart Farm</h3>
            <p class="font-base card-text p">Agricultura inteligente, focada na otimização da produção para trazer mais eficiência e diminuir
              desperdícios através da tecnologia.</p>
          </div>
          <b-button rounded class="mb-4 saiba-mais-button" @click="farmAlert()">SAIBA MAIS</b-button><br />
        </div>
        </div>
    </div>
  </section>
  <!--Fim da sessão our solutions-->
      <section id="our-mission-content"><!--Início seção our mission-->
        <div class="columns"><!--Início div columns-->
          <div class="column"><!--Início div column-->
            <div class="container mt-5"><!--Início div container-->
              <h1 class="pt-5">Nossa Missão</h1>
              <p class="font-2xl">
                Empoderar empresas e indivíduos com uma plataforma inovadora para gerenciar sensores IoT de forma eficiente. Nossa missão é transformar a complexidade dos dados em clareza e ação, promovendo a conectividade e a organização necessárias para impulsionar o crescimento e a inovação tecnológica.
              </p><br />
            </div><!--Fim div container-->
          </div><!--Fim div column-->
        </div><!--Fim div columns-->
      </section><!--Fim seção our mission-->
      <section id="our-equip-content"><!--Início seção our equip-->
        <div class="columns"><!--Início div columns-->
          <div class="column"><!--Início div column-->
            <div class="container mt-5"><!--Início div container-->
              <h1 class="pt-5">Nossa equipe</h1>
              <div id="equip-cards">
                <div class="equip-card">
                  <img src="../assets/MarcusSchebek-IMG.jpg" alt="" class="equip-img">
                  <p class="equip-name font-4xl">Marcus Schebek</p>
                </div>
                <div class="equip-card">
                  <img src="../assets/MathausHuber-IMG.jpg" alt="" class="equip-img">
                  <p class="equip-name font-4xl">Mathaus Huber</p>
                </div>
                <div class="equip-card">
                  <img src="../assets/RayssaCoelho-IMG.jpg" alt="" class="equip-img">
                  <p class="equip-name font-4xl">Rayssa Coelho</p>
                </div>
              </div>
            </div><!--Fim div container-->
          </div><!--Fim div column-->
        </div><!--Fim div columns-->
      </section><!--Fim seção our equip-->
      <footer> <!--Início da sessão de Footer-->
        <div class="footer-info">
          <div class="footer-logo">
            <img src="../assets/WhiteLogo.png" alt="">
            <p class="font-base">NOSCONECTADOS</p>
          </div>
          <div class="footer-links">
            <a href="">NOSCONECTADOS</a>
            <a href="">INFORMAÇÕES SOBRE</a>
            <a href="">AJUDA</a>
            <a href="">SENSORES</a>
            <a href="">CONTATO</a>
          </div>
        </div>
        <div class="footer-copyright">
          <p class="font-base">All rights reserved. Copyright © 2024</p>
        </div>
      </footer>
    </main>
  </template>
  <script>
  export default {
    data() {
      return {
        isSwitchedCustom: 'Light'
      }
    },
    methods: {
      success() {
        this.$buefy.toast.open({
          message: 'Obrigado pela sua avaliação!',
          type: 'is-success'
        })
      },
      showAlert() {
        this.$swal({
          title: 'Desenvolvido por Mathaus Huber',
          text: 'Entusiasta de software livre. Desenvolvedor Web Full Stack com experiência atuando no front-end e back-end. Em processo de graduação em Ciência da Computação pela Universidade Federal de Pelotas.',
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: '<a href="https://www.mathaushuber.com" target="_blank">Site</a>',
          cancelButtonText: '<a href="https://www.github.com/HuberM1998" target="_blank">Github</a>',
          imageUrl: 'https://mathaushuber.com/Imagens/perfil.jpg',
          imageWidth: 300,
          imageHeight: 300,
          imageAlt: 'Mathaus Huber: @HuberM1998',
        })
      },
      cityAlert() {
        this.$swal({
          title: 'Smart City',
          text: 'Uma smart city é uma cidade eficiente, conectada e sustentável. Por meio de inovações tecnológicas, os projetos dessas cidades buscam proporcionar um ambiente urbano que promova o desenvolvimento humano, use os recursos naturais de forma sustentável e impulsione a economia local. O conceito das smart cities proporciona uma verdadeira revolução na perspectiva sobre o espaço urbano. Muito mais do que um local para abrigar pessoas, as cidades são vistas como um ambiente que, se bem-planejado, pode favorecer a sociedade em diversos níveis. Por exemplo, por meio da Internet das Coisas (IoT), é possível utilizar dados para conectar sistemas, produtos e usuários, garantindo maior produtividade e eficiência energética. ',
          icon: 'question',
        })
      },

      campusAlert() {
        this.$swal({
          title: 'Smart Campus',
          text: 'Utiliza o conceito de Smart Cities, que promove o desenvolvimento e implementação de soluções tecnológicas e sustentáveis em diversas áreas de uma cidade. As soluções são pensadas para melhorias nas áreas de Educação, Recursos Naturais, Conectividade, Mobilidade e Segurança, Qualidade de Vida e Uso da Energia. A ideia inovadora, que envolve a adoção de práticas de uma cidade inteligente dentro de uma universidade, por meio da conexão de dados, sistemas e pessoas é um conceito que embora ainda pouco utilizado na prática, irá auxiliar na qualidade e no desempenho dos serviços em um Campus Universitário',
          icon: 'question',
        })
      },
      farmAlert() {
        this.$swal({
          title: 'Smart Farming',
          text: 'Smart farming ou agricultura inteligente é um conceito que busca conciliar a gestão agrícola à tecnologias de dados, de modo a otimizar os complexos sistemas e voláteis dinâmicas da agricultura. O smart farming está dentro de um guarda-chuva de revoluções que fazem parte da Agricultura 4.0 e Agricultura 5.0, como o digital farming e a agricultura de precisão. Assim, é possível se utilizar de dispositivos, sistemas e recursos tecnológicos para captar dados aprofundados sobre a plantação, possibilitando melhor rastreio, monitoramento, matização e análise das operações. O principal exemplo, e a grande força-motriz desse movimento, é a Internet das Coisas (IoT). Com recursos de automação e o acesso a dados atualizados em tempo real, os agricultores têm um melhor controle sobre o processo de produção e as variáveis que podem impactá-lo.',
          icon: 'question',
        })
      },
      avaliacao() {
        this.$swal({
          icon: 'error',
          title: 'Oops...',
          text: 'Você não está conectado, faça login na plataforma para concluir a avaliação!'
        })
      }
    },
  };
  </script>
  <style lang="scss" scoped>
      @import url('https://fonts.googleapis.com/css2?family=Red+Hat+Text:wght@400;700&display=swap');
      @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap');

  * {
    box-sizing: border-box
  }
  body {
    font-family: 'Red Hat Text', sans-serif;
  }
  main {
    overflow-y: hidden;
  }
  #init {
  padding: 2em;

  .columns {
    display: flex;
    flex-direction: column; 
    align-items: center; 
    text-align: center; 
    gap: 2rem; 
  }

  #init-info {
    margin-bottom: 1rem auto;

    #init-title {
      display: flex;
      flex-direction: column; 
      align-items: center; 
      justify-content: center; 

      .title-part {
        font-size: 2rem;
        text-align: center;
      }

      .overlaid {
        color: #00C4A7;
        font-weight: bold;
      }
    }

    p {
      margin-bottom: 1.5rem;
      font-size: 1rem;
      line-height: 1.5;
      text-align: start;
      width: 60%;
    }

    #init-button {
      display: flex;
      flex-direction: column; 
      align-items: center; 
      justify-content: center;
      gap: 1rem; 
      width: 100%;

      #init-signIn-button {
        font-size: 1rem;
        padding: 1rem 3.5rem;
        width: 80%; 
        max-width: 300px; 
      }

      #client-portfolio-text {
        font-size: 0.875rem;
        color: #888;
        margin: 0;
        width: 80%; 
        max-width: 300px; 
        text-align: center; 
      }
    }
  }

  img#aboutUS-init {
    width: 80%;
    max-width: 400px;
    margin-bottom: 1.5rem;
  }

  @media (min-width: 768px) {
    .columns {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      text-align: justify;
    }

    #init-info {
      flex: 1;
      margin-right: 2rem;

      #init-title {
        .title-part {
          font-size: 4rem;
        }

        .overlaid {
          font-size: 7rem;
          font-weight: bolder;
        }
      }

      p {
        font-size: 1.1rem;
        text-align: left;
        margin-top: 1em;
        width: 60%;
      }

      #init-button {
        display: flex;
        flex-direction: row; 
        align-items: center;
        justify-content: center;
        gap: 4em; 

        #init-signIn-button {
          font-size: 1.1rem;
          padding: 1rem 5rem;
        }

        #client-portfolio-text {
          font-size: 0.9rem;
          width: auto; 
          text-align: left; 
        }
      }
    }

    img#aboutUS-init {
      flex: 1;
      width: 50%;
      max-width: 600px;
      margin-bottom: 0;
    }
  }
}

#our-solutions {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2em;
  background: url("../assets/capa.png"), url("../assets/ruido.png"), linear-gradient(110deg, $primary, #7c26f8);
  background-attachment: fixed;
  text-align: center;

  .solutions-title {
    margin: 5em auto 0;
    color: white;

    h1 {
      font-size: 2.5em;
      font-weight: bold;
    }
  }

  .solutions-itens {
    display: grid;
    justify-content: center;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 1.6em;
    padding: 2em;

    @media (max-width: 767px) {
      grid-template-columns: 1fr; 
      margin: 0 auto; 
    }

    @media (min-width: 581px) and (max-width: 1024px) {
      display: flex; 
      flex-direction: column;
      align-items: center; 
      justify-content: center; 
      max-width: 75%; 
      margin: 0 auto; 
    }
  }

  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background-color: white;
    box-shadow: 0px 29px 38px -15px rgba(0, 0, 0, 0.43);
    padding: 0.5em;
    max-width: 18vw;
    min-height: 42vh;
    height: 100%;
    border-radius: 0.5em;
    box-sizing: border-box;

    @media (max-width: 590px) {
      max-width: 90%; 
    }
    @media (min-width: 581px) and (max-width: 1024px) {
      max-width: 70%;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 90%;
      height: 200px;
      background-color: lightgrey;
      background-size: cover;
      background-position: center;
      margin: 1.2em 0;
      border-radius: 0.3em;

      @media (max-width: 480px) {
        height: auto; 
      }
    }

    .card-text {
      margin-top: 1.5em;
      width: 98%;
      justify-content: center;
      text-align: center; 

      @media (min-width: 581px) and (max-width: 1024px) {
        margin: 0 auto; 
      }
    }
  }

  .saiba-mais-button {
    width: 100%;
    border: none;
    color: #fff;
    margin-top: 1em;
    align-items: end;
    background-color: #00D1B2;
  }

  p {
    max-width: 52ch;
    min-height: 40%;
    line-height: 1.5;
    padding: 1em;
  }
}

  #our-mission-content {
  display: flex;
  flex-direction: column; 
  align-items: center;
  justify-content: center;
  padding: 1rem;
  height: auto;
  background-color: #00D1B2;
  gap: 1.5rem; 

  h1, p {
    padding: 0.75em 1em;
    color: white;
  }

  h1 {
    font-size: 2rem;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
  }

  p {
    text-align: start;
    max-width: 90%; 
    margin: 0 auto; 
    font-size: 1rem; 
  }

  @media (min-width: 768px) {
    flex-direction: row; 
    height: 55vh; 
    padding: 0;

    h1 {
      flex: 1;
      font-size: 3rem; 
      text-align: left; 
    }

    p {
      flex: 1;
      max-width: 43vw; 
      font-size: 1.1rem; 
      text-align: left; 
      margin: 0; 
    }
  }
}
#our-equip-content {
  display: flex;
  flex-direction: column; 
  justify-content: center;
  align-items: center;
  padding: 2rem;
  min-height: 50vh;

  h1 {
    margin: 1em auto;
    text-align: center;
    color: #00D1B2;
    font-size: 2rem; 
  }

  #equip-cards {
    display: flex;
    flex-direction: column; 
    align-items: center;
    justify-content: center;
    gap: 2rem; 
    width: 90vw; 
    margin: 2rem auto; 

    .equip-card {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-width: 70vw; 
      text-align: center;

      img {
        max-width: 35vw; 
        max-height: 25vh; 
        border-radius: 50%;
      }

      .equip-name {
        font-weight: bold;
        margin-top: 1rem;
        font-size: 1.25rem;
      }

      .equip-role {
        margin-top: -10px;
        font-size: 1rem; 
      }
    }
  }

  @media (min-width: 768px) {
    h1 {
      font-size: 3rem; 
      font-weight: bold;
    }

    #equip-cards {
      flex-direction: row; 
      gap: 5em; 
      width: 60vw; 

      .equip-card {
        max-width: 12vw; 

        img {
          max-width: 12vw; 
          max-height: 40vh; 
        }

        .equip-name {
          font-size: 1.5rem; 
        }

        .equip-role {
          font-size: 1.1rem; 
          margin-top: -24px;
        }
      }
    }
  }
}
footer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  .footer-info {
    min-height: 22.9vh;
    width: 100%;
    background-color: #007463;
    padding: 2em 0;
    
    .footer-logo {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: white;
      font-family: 'Arial', sans-serif;
      font-size: 1rem;
      margin-bottom: 2em;

      img {
        max-width: 150px;
        margin-bottom: 1em;
      }
    }

    .footer-links {
      display: flex;
      flex-direction: column; 
      align-items: center;
      justify-content: center;
      gap: 1.5em; 
      width: 80%;
      margin: 0 auto;

      a {
        color: white;
        font-size: 1rem;
        text-decoration: none;
        transition: color 0.3s;

        &:hover {
          color: #00C4A7;
        }
      }
    }
  }

  .footer-copyright {
    width: 100%;
    background-color: #005D4F;
    padding: 1em 0;
    font-family: 'Montserrat', sans-serif;
    font-weight: 300;
    font-size: 1rem;
    color: white;
    text-align: center;
  }

  @media (min-width: 768px) {
    .footer-info {
      padding: 3em 0;

      .footer-logo {
        font-size: 1.2rem;

        img {
          max-width: 200px;
        }
      }

      .footer-links {
        flex-direction: row; 
        gap: 4em;
        width: 60%;
      }
    }

    .footer-copyright {
      font-size: 1.1rem;
    }
  }
}

</style>